import { getConnectionOrVendorType, isDetectedDataset } from '../lib/ResourceUtils';
import has from 'lodash/has';
import { useSelector } from 'react-redux';
import {
  RESOURCE_TYPE_DATA_SET,
  RESOURCE_TYPE_FLOW,
  RESOURCE_TYPE_SINK,
  RESOURCE_TYPE_SOURCE,
} from '../constants/resourceTypes';
import useEntities from 'new/state/entities/repository/useEntities';
import usePaging from 'new/state/paging/repository/usePaging';

export function getResourceEntityKey(resourceType) {
  if (!resourceType) {
    return undefined;
  }
  const keys = {
    [RESOURCE_TYPE_SINK]: 'sink',
    [RESOURCE_TYPE_SOURCE]: 'source',
    [RESOURCE_TYPE_FLOW]: 'source',
    [RESOURCE_TYPE_DATA_SET]: 'dataSet',
  };
  return keys[resourceType];
}

export const getResourceMeta = ({ resourceType, data_credentials, metaInfoById, entities }) => {
  return (id) => {
    const entityKey = getResourceEntityKey(resourceType);
    if (!entityKey) {
      return {};
    }
    if (!resourceType || !id) {
      return {};
    }
    const { vendors, credentials } = entities;

    let isDetected = false;

    const entity = entities[entityKey + 's'][id];
    if (resourceType === RESOURCE_TYPE_DATA_SET) {
      isDetected = isDetectedDataset(entity);
    }

    let source = entity;
    if (isDetected) {
      source = entities.sources[entity.data_source];
    }

    const typeKey = entityKey === 'credential' ? 'credentials' : entityKey;

    let connectionOrVendorType = getConnectionOrVendorType(
      source,
      vendors,
      resourceType === RESOURCE_TYPE_DATA_SET ? 'source_type' : typeKey + '_type',
      'vendor_id',
    );

    let credential = {};
    if (!!data_credentials && has(credentials, data_credentials)) {
      credential = credentials[data_credentials];
    }

    const credentialConnectionType =
      credential && has(credential, 'id')
        ? getConnectionOrVendorType(credential, vendors, 'credentials_type', 'vendor_id')
        : null;

    const meta =
      connectionOrVendorType && has(metaInfoById, connectionOrVendorType)
        ? metaInfoById[connectionOrVendorType]
        : {};

    return {
      ...meta,
      credential,
      credentialConnectionType,
      connectionOrVendorType: connectionOrVendorType || undefined,
    };
  };
};

export function useResourceMeta(resourceType, id, data_credentials = null) {
  const { data: entities } = useEntities();
  const metaInfoById = useSelector((state: any) => state.paging.metaInfoById);

  if (!id) {
    return {};
  }

  return getResourceMeta({
    resourceType,
    data_credentials,
    entities,
    metaInfoById,
  })(id);
}
